import React from 'react'

const DuplicateOrderConfirmation = ({onConfirm, onCancel}) => {
  return(
    <div className="modal" data-backdrop="static" data-keyboard="false"
      tabIndex="-1" role="dialog" aria-hidden="true"
      style={{paddingTop:'15%', overflowY:'visible',backgroundColor: 'rgba(30,30,30,.7)',display:'block'}}>
      <div className="modal-dialog modal-m">
        <div className="modal-content">
          <div className="modal-header">
            <h3 style={{margin:0}}>Будет создан такой же заказ со сметой</h3>
          </div>
          <div className="modal-body text-right">
            <button type="button" className="btn btn-default" onClick={onCancel}>Отмена</button>
            <button type="button" className="btn btn-warning" onClick={onConfirm}>Подтвердить</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DuplicateOrderConfirmation;



// WEBPACK FOOTER //
// ./src/components/ui/DuplicateOrderConfirmation.jsx